import { Component, ErrorInfo, ReactNode } from "react";

type Props = {
	children: ReactNode;
};

type State = {
	failed: boolean;
};

/**
 * The indicator only informs: if it fails to render, it disappears and the
 * header or the login form around it keeps working.
 */
export default class ConnectionErrorBoundary extends Component<Props, State> {
	state: State = { failed: false };

	static getDerivedStateFromError(): State {
		return { failed: true };
	}

	// React calls it on the instance; it only logs, so no `this` is needed.
	// eslint-disable-next-line class-methods-use-this
	componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		// eslint-disable-next-line no-console
		console.error(
			"[connectionQuality] render error",
			error,
			errorInfo.componentStack,
		);
	}

	render() {
		return this.state.failed ? null : this.props.children;
	}
}
